import { render, staticRenderFns } from "./edit-driver.vue?vue&type=template&id=f718d576&scoped=true"
import script from "./edit-driver.vue?vue&type=script&lang=js"
export * from "./edit-driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f718d576",
  null
  
)

export default component.exports